export default function Checkbox({ className = '', ...props }) {
    return (
        <input
            {...props}
            type="checkbox"
            className={
                'rounded border-gray-300 text-uhl-light-blue shadow-sm focus:ring-[#5ba4bd] ' +
                className
            }
        />
    );
}
